import React, { Fragment, useEffect, useState } from "react";
import { withApollo } from "react-apollo";
import { connect } from "react-redux";
import { compose } from "redux";
import { CircularProgress } from "@mui/material";
import styled from "styled-components";
import { handleReauthentication } from "../schema/helpers/review/EquipmentReviewTools";

export const FullScreenCenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0;
  width: 100vw;
  height: 100vh;, ...syncFields
`;

export const ReAuthenticationHandler = ({ client, children, user }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    handleReauthentication(
      client,
      user.id,
      setLoading
    );
    // eslint-disable-next-line
  }, []);

  return loading ? (
    <FullScreenCenteredContainer>
      <CircularProgress data-testid="loading" size={80} />
    </FullScreenCenteredContainer>
  ) : (
    <Fragment>{children}</Fragment>
  );
};

export default compose(connect(), withApollo)(ReAuthenticationHandler);
